import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { NextImage } from '@/components/NextImage';
import { Typography } from '@/components/Typography';

import { ReactComponent as PlusSVG } from '@/assets/icons/plus.svg';

export const AddButton = styled.button`
  width: 100%;
  display: flex;
  position: relative;

  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `}
`;

export const Wrapper = styled(Flex)`
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const ButtonImageWrapper = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  height: 56px;
  width: 120px;
`;

export const ButtonImage = styled(NextImage)`
  object-fit: contain;
`;

export const PlusIcon = styled(PlusSVG)`
  width: 24px;
  height: 24px;
`;

export const ButtonText = styled(Typography)`
  color: ${({ theme }) => theme.colors.primaryBlue};
`;
